import Base from '../../components/base';

const EVENTS = {
	typeChange: 'typeChange',
};

class ChartTypeSelector extends Base {
	constructor(el) {
		super(el);

		// Event listeners
		this.on('change');
	}

	get activeEndpointType() {
		return this.el.querySelector(':checked').getAttribute('data-type');
	}

	get activeChartType() {
		return this.el.querySelector(':checked').value;
	}

	set disabled(boolean) {
		this.el.disabled = boolean;
	}

	onChange() {
		const event = new CustomEvent(EVENTS.typeChange, {
			bubbles: true,
		});

		this.el.dispatchEvent(event);
	}

	setValue(value) {
		this.el.value = value;
	}
}

export default ChartTypeSelector;

export {
	EVENTS,
};

